import { createReducer, on } from '@ngrx/store';
import { initialRegisterState } from './register_state';
import {
  updateCaptchaToken,
  updateError,
  updatePopover,
  updateSaving,
  updateUser
} from './register_actions_creator';

export const registerReducer = createReducer(
  initialRegisterState,
  on(updateUser, (state, action) => ({...state, user: action.user})),
  on(updateError, (state, action) => ({...state, error: action.error})),
  on(updatePopover, (state, action) => ({...state, popover: action.popover})),
  on(updateSaving, (state, action) => ({...state, saving: action.saving})),
  on(updateCaptchaToken, (state, action) => ({...state, captchaToken: action.captchaToken})),
);
